import './Footer.css';


const Footer = () => {
  return (
    <footer className="footer-div">
      <div className="footer-content">
        <div className="footer-links">
          <a 
            href="https://github.com/shaaronl" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            GitHub
          </a>
          <a 
            href="https://www.linkedin.com/in/sharon-liangg/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            LinkedIn
          </a>
          <a 
            href="mailto:shaaronliang@gmail.com" 
            className="footer-link"
          >
            Email
          </a>
          <a 
            href="/SharonLiang2026.pdf" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-link"
          >
            Resume{' '}
          </a>
        </div>
      </div>
      
      <div className="footer-bottom-center">
        <p>© 2025 Sharon Liang</p>
      </div>
    </footer>
  );
};

export default Footer;
